import cx from 'classnames';
import createReactAngularDirective from '../../lib/createReactAngularDirective';
import { ReviewPage } from '../../react-components/ReviewPage';
import s from '../../controllers/Step2Step3Ctrl/step2Step3Ctrl.module.css';

export default createReactAngularDirective({
  Component: ReviewPage,
  directiveName: 'reviewPage',
  withProvider: true,
  watch: true,
  replace: true,
  dynamicTemplate: (store) => {
    const { returnMethods: { selectedMethodKey } = {} } = store.getState();
    const className = cx(s.step_3_container, `step-3-container-${selectedMethodKey}`);
    return `<div class="${className}"></div>`;
  },
});
